import { zStringRequired } from '@/general/src/other/validation.js'
import { z } from 'zod'

export const zAddAgentPermanentRecognitionTokensForAdminEndpointInput = z.object({
  agentId: zStringRequired,
  tokensCount: z.coerce.number().int(),
})
